import React, { useState } from 'react';
import {
  faAngleLeft,
  faAngleRight,
  faCalendarDay,
  faCalendarRange,
} from '@fortawesome/pro-light-svg-icons';
import { Box, Menu, MenuItem } from '@mui/material';
import { ColorPalette } from '../config';
import { getCalendarViewDisplay, getHeaderTitle } from './calendar-helpers';
import { CalendarView } from './calendar-types';
import { CalendarToolbarButton } from './calendar-toolbar-button';
import { ICalendarToolbarProps } from './calendar-toolbar-types';

const allCalendarViews: CalendarView[] = ['agenda', 'day', 'week', 'month', 'threeMonths', 'year'];

export function CalendarToolbarV1(props: ICalendarToolbarProps) {
  const {
    firstDate,
    onNextClick,
    onPreviousClick,
    onCalendarViewChange,
    currentCalendarView,
    onTodayClick,
  } = props;
  const [calendarViewAnchorEl, setCalendarViewAnchorEl] = useState<null | HTMLElement>(null);
  const calendarViewOpen = Boolean(calendarViewAnchorEl);

  function handleCalendarViewChange(view: CalendarView) {
    onCalendarViewChange(view);
    setCalendarViewAnchorEl(null);
  }

  return (
    <Box
      display="flex"
      sx={{
        padding: '10px',
        backgroundColor: ColorPalette.LightHeaderBackground,
        borderRadius: '3px 3px 0 0',
        border: 'solid 1px rgba(0, 0, 0, 0.15)',
        borderBottom: 'none',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box sx={{ fontFamily: 'Roboto', fontSize: '14px', fontWeight: 500, flex: 1 }}>
        {getHeaderTitle(currentCalendarView, firstDate)}
      </Box>
      <Box display="flex" sx={{ fontFamily: 'Roboto', fontSize: '14px', fontWeight: 500 }}>
        <CalendarToolbarButton
          icon={faCalendarRange}
          onClick={event => setCalendarViewAnchorEl(event.currentTarget)}
          toolbarText="Kalender visning"
        />
        <Menu
          anchorEl={calendarViewAnchorEl}
          open={calendarViewOpen}
          onClose={() => setCalendarViewAnchorEl(null)}
        >
          {allCalendarViews.map(view => (
            <MenuItem
              key={view}
              sx={{ fontWeight: currentCalendarView === view ? 700 : undefined }}
              onClick={() => handleCalendarViewChange(view)}
            >
              {`Vis ${getCalendarViewDisplay(view)}`}
            </MenuItem>
          ))}
        </Menu>
        {currentCalendarView !== 'agenda' && (
          <>
            <CalendarToolbarButton icon={faCalendarDay} onClick={onTodayClick} toolbarText="I dag" />
            <CalendarToolbarButton icon={faAngleLeft} onClick={onPreviousClick} toolbarText="Tilbage" />
            <CalendarToolbarButton icon={faAngleRight} onClick={onNextClick} toolbarText="Frem" />
          </>
        )}
      </Box>
    </Box>
  );
}
